import { render, staticRenderFns } from "./ImprintView.vue?vue&type=template&id=afaae5d0&"
import script from "./ImprintView.vue?vue&type=script&lang=js&"
export * from "./ImprintView.vue?vue&type=script&lang=js&"
import style0 from "./ImprintView.vue?vue&type=style&index=0&id=afaae5d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports